import { render, staticRenderFns } from "./view-video.vue?vue&type=template&id=6c85c7b4&scoped=true"
import script from "./view-video.vue?vue&type=script&lang=js"
export * from "./view-video.vue?vue&type=script&lang=js"
import style0 from "./view-video.vue?vue&type=style&index=0&id=6c85c7b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c85c7b4",
  null
  
)

export default component.exports